<script setup lang="ts">

import { useAssetStore } from '@/stores/assetStore.ts'
import { defineProps, computed } from 'vue'
import StandardCard from '@/components/Elements/Cards/StandardCard.vue'
import { CDN } from '@/models/cdn.ts'
import GenericIconWithColoredNumber from '@/components/Elements/Images/Icons/GenericIconWithColoredNumber.vue'
import StyledImage from '@/components/Elements/Images/StyledImage.vue'
import { useGameStore } from '@/stores/gameStore.ts'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

/**
 * Props
 */
const props = defineProps({
  ministerCode: {
    type: String,
    required: true
  }
})

/**
 * Stores / models
 */
const assetStore = useAssetStore()
const gameStore = useGameStore()

/**
 * Computed
 */
const data = computed(() => {
  return assetStore.findMinisterByCode(props.ministerCode)!
})

const ministerName = computed(() => {
  return t(`government.ministers.${props.ministerCode}.name`)
})

const ministryData = computed(() => {
  return assetStore.findMinistryByMinisterCode(props.ministerCode)!
})

const fired = computed(() => {
  const data = gameStore.playerMinisters.get(props.ministerCode)
  if (data) {
    return data.fired == 1
  } else {
    return false
  }
})

/**
 * Functions
 */
const openMinister = () => {
  gameStore.modalType = 'ministryCandidate'
  gameStore.modalData = {
    code: ministryData.value.code
  }
}

</script>

<template>
  <StandardCard :title="ministerName" top-padding="0" @click="openMinister" class="cursor-pointer">
    <div class="relative">
      <StyledImage
          :src="CDN.ministerImage(data.code)"
          alt="Minister image"
          size="full"
          :grayscale="fired"
      />
      <div v-if="fired" class="absolute inset-0 flex items-center justify-center z-10">
        <div class="text-5xl font-bold text-red-500" style="text-shadow: 0 0 8px white;">
          {{ t('government.cabinet.firedStatus') }}
        </div>
      </div>
      <div v-if="!fired" class="absolute bottom-0 left-0 right-0 bg-black/70 py-2 flex justify-center rounded-b">
        <div class="flex items-center gap-2">
          <span class="text-metal-400">{{ t('government.cabinet.salary') }}</span>
          <GenericIconWithColoredNumber :amount="-data.salary" type="credit" />
        </div>
      </div>
    </div>
  </StandardCard>

</template>

<style scoped lang="scss">

</style>